export default "__VITE_ASSET__BiMIdaTc__"